import { ConfigurationError } from "@/types/errors";

/*
 * TODO: if this ever gets to the point where we need to support additional "cultures" - this is the pattern
 *
 * const englishUsCultureKey = 'en-US';
 * cont labelByCultureMap: ReadonlyMap< string, ReadonlyMap< string, string > > =
 *      new Map< string, ReadonlyMap< string, string > >( [
 *          [ englishUsCultureKey, new Map< string, string >( [
 *                  [ 'lblXXX', 'XXX' ],
 *                  ...
 *              ]
 *          ]
 *      ] );
 *
 * label( key: string, culture?: string = englishUsCultureKey ): string {
 *     const labelValue #labelByCultureMap.get( culture ).get( key );
 *      if ( !labelValue ) {
 *          throw new ConfigurationError(
 *              `The label key '${ key }' is not currently defined. Update the configuration and rebuild.`
 *          );
 *      }
 *
 *      return labelValue;
 *  }
 */

// TODO: use a service or global json file that can be edited within a tool that makes this more manageable
const labelMap: ReadonlyMap< string, string > = new Map( [
    [ 'lblAlliance', 'Alliance' ],
    [ 'lblDashboard', 'Dashboard' ],
    [ 'lblServices', 'Services' ],
    [ 'lblMarketAlerts', 'Market Alerts' ],
    [ 'lblTradeOfTheDay', 'Trade of the Day' ],
    [ 'lblSectorAlerts', 'Sector Alerts' ],
    [ 'lblTradeAlerts', 'Trade Alerts' ],
    [ 'lblLearning', 'Learning' ],
    [ 'lblArticles', 'Articles' ],
    [ 'lblBonusReports', 'Bonus Reports' ],
    [ 'lblCourses', 'Courses' ],
    [ 'lblSectorEdge', 'Sector Edge' ],
    [ 'lblWebinars', 'Webinars' ],
    [ 'lblTools', 'Tools' ],
    [ 'lblSectorBpis', 'Sector Demand Charts (BPIs)' ],
    [ 'lblEtfListing', 'ETF Listing by Sector' ],
    [ 'lblMajorIndexBreadth', 'Major Index Demand Charts' ],
    [ 'lblNyseBpi', 'Market Demand (NYSE BPI)' ],
    [ 'lblPortfolioBuilder', 'Portfolio Builder' ],
    [ 'lblPositionSizeCalculator', 'Position Size Calculator' ],
    [ 'lblRsProxy', 'URGENCY' ],
    [ 'lblRsMatrix', 'URGENCY Tracker - RS Matrix' ],
    [ 'lblSectorRelativeRankingTitle', 'URGENCY Ranking (45 sectors)' ],
    [ 'lblSectorRsRankTitle', 'URGENCY Rank' ],
    [ 'lblSector', 'Sector' ],
    [ 'lblSectors', 'Sectors' ],
    [ 'lblBpiProxy', 'Sector Demand' ],
    [ 'lblSectorTree', 'Sector Tree' ],
    [ 'lblSpreadCalculators', 'Spread Calculators' ],
    [ 'lblSpreadAnalyzer', 'Spread Analyzer' ],
    [ 'lblMyAccount', 'My Account' ],
    [ 'lblOptionsCalculator', 'Options Calculator' ],
    [ 'lblProfile', 'Profile' ],
    [ 'lblBilling', 'Billing' ],
    [ 'lblMyLibrary', 'My Library' ],
    [ 'lblSignOut', 'Sign Out' ],
    [ 'lblSupport', 'Support' ],
    [ 'lblAppStatus', 'App Status' ],
    [ 'lblFeatureNews', 'Feature News' ],
    [ 'lblContactUs', 'Contact Us' ],
    [ 'lblContact', 'Contact' ],
    [ 'lblReset', 'App Reset' ],
    [ 'lblPolicies', 'Policies' ],
    [ 'lblPrivacyPolicy', 'Privacy Policy' ],
    [ 'lblRefundPolicy', 'Refund Policy' ],
    [ 'lblSmsPolicy', 'SMS Text Policy' ],
    [ 'lblTermsAndConditions', 'Terms & Conditions' ],
    [ 'lblWhitelistInstructions', 'Whitelist Instructions' ],
    [ 'lblSocial', 'Social' ],
    [ 'lblFacebook', 'Facebook' ],
    [ 'lblX', 'Twitter' ],
    [ 'lblInstagram', 'Instagram' ],
    [ 'lblYouTube', 'YouTube' ],
    [ 'lblDiscord', 'Discord' ],

    [ 'lblSectorSpotlight', 'Weekly Sector Spotlight' ],
    [ 'lblSectorBreadth', 'Sector Breadth' ],
    [ 'lblMoreDetails', 'More Details' ],

    [ 'lblSectorRsColumnTitle', 'URGENCY / S&P500' ],
    [ 'lblPeerRsColumnTitle', 'URGENCY / Sector' ],
    [ 'lblSecurityMarketRsColumnTitle', `Stock's Strength`  ],
    [ 'lblSectorRsColumnHoverTooltip', 'URGENCY compared to the equally weighted S&P 500' ],
    [ 'lblSectorBpiSignalTitle', 'Long-Term Demand' ],
    [ 'lblSectorBpiSignalHoverTooltip', '???' ],
    [ 'lblSectorBpiColumnTitle', 'Short-Term Demand' ],
    [ 'lblBpiColumnHoverTooltip', '???' ],
    [ 'lblSectorP30SignalTitle', 'Precision Demand' ],
    [ 'lblSectorP30SignalHoverTooltip', '???' ],

    [ 'lblSectorsAllTitle', 'All' ],
    [ 'lblSectorsRelativeStrengthTitle', 'Long-Term / Investors'],
    [ 'lblSectorsBullishPercentIndexTitle', 'Short-Term / Traders' ],
    [ 'lblSectorsP30SignalTitle', 'Precision Demand' ],
    [ 'lblSectorsP30ColumnTitle', 'Ultra Precision Demand' ],
    [ 'lblSectorsEwValueTitle', 'EW Value' ],
    [ 'lblSectorsEwPercentChgTitle', 'Sector Index % Change' ],

    [ 'lblAvailableServices', 'Available Services' ],
    [ 'lblProducts', 'Products' ],
    [ 'lblAbout', 'About' ],
    [ 'lblSignUp', 'Sign Up' ],
    [ 'lblLogIn', 'Log In' ],
    [ 'lblBpiChartTitle', 'Long-Term Demand' ],
    [ 'lblBpiChart', 'BPI' ],
    [ 'lblPercentThirtyChartTitle', 'Precision Demand' ],
    [ 'lblPercentThirtyChart', '%30' ],
    [ 'lblPercentTenChartTitle', 'Micro-Demand' ],
    [ 'lblPercentTenChart', '%10' ],
    [ 'lblSectorBellCurveXColumnInstitutions', 'Institutions Buying the Sector' ],
    [ 'lblSectorBellCurveXColumn', '("Buy Now"...BPI in Xs)' ],
    [ 'lblSectorBellCurveOColumnInstitutions', 'Institutions Selling the Sector' ],
    [ 'lblSectorBellCurveOColumn', '("Wait"...BPI in Os)' ],

    [ 'lblSymbol', 'Symbol' ],
    [ 'lblSector', 'Sector' ],
    [ 'lblStockEntryPrice', 'Stock (Entry $)' ],
    [ 'lblOptionsEntryPrice', 'Options (Entry $)' ],
    [ 'lblLastClose', 'Last Close' ],
    [ 'lblStance', 'Stance' ],
    [ 'lblBpiStatus', 'BPI Status' ],
    [ 'lblSectorRS', 'Sector URGENCY' ],
    [ 'lblPeerRS', 'Peer URGENCY' ],
    [ 'lblMarketRS', 'Market URGENCY' ],
    [ 'lblCurrentStockGains', 'Current Stock Gains' ],
    [ 'lblCurrentOptionsGains', 'Current Options Gains' ],
    [ 'lblInitiated', 'Initiated' ],
    [ 'lblLastUpdated', 'Last Updated' ],
    [ 'lblMostRecentCheckPoint', 'Most Recent Checkpoint' ],
    [ 'lblPriceTarget', 'Price Target' ],
    [ 'lblStopLoss', 'Stop Loss' ],
    [ 'lblMonthEndGains', 'M/E Gains' ],
    [ 'lblMaxGains', 'Max Gains' ],
    [ 'lblOptionExpirationMonth', 'Option Expiration Month' ],
    [ 'lblOptionStrike', 'Option Strike' ],
    [ 'lblActions', 'Actions' ],
    [ 'lblExited', 'Exited' ],
    [ 'lblStockExitPrice', 'Stock (Exit $)' ],
    [ 'lblOptionExitPrice', 'Option (Exit $)' ],
    [ 'lblBuyUnder', 'Buy Under' ],
    [ 'lblStockGains', 'Stock P&L' ],
    [ 'lblOptionGains', 'Option P&L' ],
    [ 'lblWeighting', 'Weighting' ],

    [ 'lblBullishLabel', 'Buy Now' ],
    [ 'lblBearishLabel', 'Wait' ],

    [ 'lblRsBullishLabel', 'Buy Now' ],
    [ 'lblRsBearishLabel', 'Wait' ],
    [ 'lblBpiBullishLabel', 'Buy Now' ],
    [ 'lblBpiBearishLabel', 'Wait' ],
    [ 'lblP30BullishLabel', 'Buy Now' ],
    [ 'lblP30BearishLabel', 'Wait' ],
    [ 'lblP10BullishLabel', 'Buy Now' ],
    [ 'lblP10BearishLabel', 'Wait' ],

    [ 'lblLongTermIndication', 'Long-Term' ],
    [ 'lblIntermediateTermIndication', 'Intermediate-Term' ],
    [ 'lblShortTermIndication', 'Short-Term' ],

    [ 'lblRsMatrixBuyWithXDescription', 'Long-Term and Short-Term = Greater URGENCY Buying' ],
    [ 'lblRsMatrixBuyWithODescription', 'Long-Term = Greater URGENCY Buying, Short-Term = Lower URGENCY Buying' ],
    [ 'lblRsMatrixSellWithXDescription', 'Long-Term = Lower URGENCY Buying, Short-Term = Greater URGENCY Buying' ],
    [ 'lblRsMatrixSellWithODescription', 'Long-Term = Lower URGENCY Buying, Short-Term = Lower URGENCY Buying' ],

    [ 'lblRelativeBullishIndication', 'Above Average' ],
    [ 'lblRelativeBearishIndication', 'Below Average' ]
] );

export function useLabelService() {
    function label( key: string ): string {
        const labelValue = labelMap.get( key );
        if ( !labelValue ) {
            throw new ConfigurationError(
                `The label key '${ key }' is not currently defined. Update the configuration and rebuild.`
            );
        }

        return labelValue!;
    }

    return {
        label
    }
}

export type LabelService = ReturnType< typeof useLabelService >;